var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{attrs:{"role":"tablist"}},[_c('mobile-admin-user-tab'),_c('mobile-admin-emprunts-tab'),_c('mobile-admin-local-tab'),_c('mobile-admin-evenements-tab')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Administration")])])
}]

export { render, staticRenderFns }